import React from 'react'
import { ContentTabLink, ContentTabs } from '../../ui/AccountUI'
import { useSelector } from 'react-redux';
import { selectTransactionSettings } from '../../selectors/settings-selectors';
import { t } from '../../i18n';
import { Route } from 'react-router';
import CasinoTransactions from './CasinoTransactions';
import PokerTransactions from './PokerTransactions';
import SportsbookTransactions from './SportsbookTransactions';
import WalletTransactions from './WalletTransactions';
import OtherTransactions from './OtherTransactions';

export default function TransactionsPage() {
    const settings = useSelector(selectTransactionSettings);

    return (
        <div className='transaction-page__container'>
            <ContentTabs>
                <ContentTabLink to={"/account/transactions/wallet"} exact>{t("transactions.wallet")}</ContentTabLink>
                {settings?.pokerEnabled && (
                    <ContentTabLink to={"/account/transactions/poker"} exact>{t("transactions.poker")}</ContentTabLink>
                )}
                {settings?.casinoEnabled && (
                    <ContentTabLink to={"/account/transactions/casino"} exact>{t("transactions.casino")}</ContentTabLink>
                )}
                {settings?.sportsbookEnabled && (
                    <ContentTabLink to={"/account/transactions/sports"} exact>{t("transactions.sportsbook")}</ContentTabLink>
                )}
                {settings?.racingEnabled && (
                    <ContentTabLink to={"/account/transactions/racing"} exact>{t("transactions.racing")}</ContentTabLink>
                )}
                <ContentTabLink to={"/account/transactions/other"} exact>{"Other"}</ContentTabLink>
            </ContentTabs>
            <div className='tp-tableContainer transactions'>
                <Route path={"/account/transactions/wallet"} component={WalletTransactions} />
                <Route path={"/account/transactions/poker"} component={PokerTransactions} />
                <Route path={"/account/transactions/casino"} component={CasinoTransactions} />
                <Route path={"/account/transactions/sports"} component={SportsbookTransactions} />
                <Route path={"/account/transactions/other"} component={OtherTransactions} />

            </div>
        </div>
    )
}
